import { Text, View } from 'react-native';
import styled from 'styled-components/native';

export const SeriesTable = styled(View)``;
export const SeriesTableHeader = styled(View)`
    height: 24px;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.text.tertiary};
`;

export const SeriesNumberCell = styled(Text)<{ filled?: boolean }>`
    align-items: center;
    justify-content: center;
    width: 32px;
    color: ${({ theme, filled }) => (filled ? theme.text.positive : theme.text.tertiary)};
`;

export const SeriesInputHeaderCell = styled(Text)`
    flex: 1;
    text-align: center;
    margin-right: 16px;
    color: ${({ theme }) => theme.text.tertiary};
`;

export const SeriesCheckboxCell = styled(View)`
    align-items: center;
    justify-content: center;
    width: 24px;
`;
